{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://modules/settlement",
  "title": "Settlement",
  "description": "Tax settlement configuration — election window, default type, and available methods.",
  "type": "object",
  "$defs": {
    "settlementConfiguration": {
      "type": "object",
      "properties": {
        "defaultSettlementTypeId": {
          "type": "string",
          "title": "Default Settlement Type",
          "format": "uuid",
          "widget": "select",
          "actionId": "FETCH_SETTLEMENT_TYPES"
        },
        "windowStart": {
          "type": "number",
          "title": "Election Window Start",
          "description": "Number of days before the grant date that the election window opens",
          "displayFormat": "number",
          "endAddon": "DAYS"
        },
        "windowEnd": {
          "type": "number",
          "title": "Election Window End",
          "description": "Number of days before the grant date that the election window closes",
          "displayFormat": "number",
          "endAddon": "DAYS"
        },
        "settlementMethods": {
          "type": "array",
          "title": "Tax Settlement Methods Available",
          "widget": "select",
          "actionId": "FETCH_SETTLEMENT_TYPES",
          "isMulti": true,
          "multiVariant": "checkbox",
          "arrayItemKey": "settlementTypeId"
        }
      }
    },
    "settlementTypeId": {
      "type": "string",
      "title": "Settlement Type",
      "format": "uuid",
      "widget": "select",
      "actionId": "FETCH_SETTLEMENT_TYPES"
    }
  }
}
